import { State } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CommentsState } from './comments/comments.state';

@State({
  name: 'details',
  children: [CommentsState]
})
@Injectable()
export class InfoState {
}
